import { Box } from '@mui/system';
import Textinput from '../../components/formlib/Textinput';
import MediumTypography from '../../components/formlib/MediumTypography';
import CheckBoxComponent from '../../components/formlib/CheckBoxComponent';
import CommentTextbox from '../../components/formlib/CommentTextbox';

type FollowUpActionQuestionType = {
  id: string;
  displayQueId: string;
  displayQuetext: string;
  textAreaSize?: string;
  textAreaType?: string;
};

type ASQFollowUpActionComponentType = {
  followUpActionQuestion: FollowUpActionQuestionType[];
  value?: { followUpChecked: boolean }[];
  onClickChange?: (value: boolean, index: number) => void;
  textInputValue?: { followUptextInputValues: string }[];
  handleTextInputChange?: (text: string, index: number) => void;
  onOtherCommentValue?: { followUpComment: string }[];
  handleOtherCommentChange?: (text: string, index: number) => void;
};

function ASQFollowUpActionComponent({
  followUpActionQuestion,
  value,
  onClickChange,
  textInputValue,
  handleTextInputChange,
  onOtherCommentValue,
  handleOtherCommentChange,
}: Readonly<ASQFollowUpActionComponentType>) {
  return (
    <Box>
      {followUpActionQuestion.map((item, index) => (
        <Box key={item.id}>
          <CheckBoxComponent
            ischecked={value?.[index]?.followUpChecked ?? false}
            CheckHandleChange={(e) =>
              onClickChange && onClickChange(e.target.checked, index)
            }
          />
          {item.displayQuetext.split('__').map((data, dataIndex) => (
            <Box sx={{ display: 'inline' }} key={item.id}>
              {dataIndex > 0 && (
                <Textinput
                  key={item.displayQueId}
                  Value={textInputValue?.[index]?.followUptextInputValues ?? ''}
                  handlechange={(e) => {
                    const inputValue = e;
                    const regexPattern = item.textAreaType
                      ? new RegExp(item.textAreaType)
                      : undefined;
                    if (
                      handleTextInputChange &&
                      (!regexPattern || regexPattern.test(inputValue))
                    ) {
                      handleTextInputChange(inputValue, index);
                    }
                  }}
                  sxProps={{
                    width:
                      item.textAreaSize === 'small'
                        ? '60px'
                        : item.textAreaSize === 'medium'
                        ? '120px'
                        : '150px',
                    top: '4px',
                    paddingX: '4px',
                  }}
                  inputProps={{
                    style: {
                      height: '24px',
                      paddingLeft: '6px',
                      paddingRight: '6px',
                    },
                    className: 'translate',
                  }}
                />
              )}
              <Box sx={{ display: 'inline-flex' }}>
                <MediumTypography
                  sxProps={{ fontSize: 14, fontWeight: 500 }}
                  labelid="ASQFollowUpActionQuestion"
                  defaultlabel={data}
                />
              </Box>
              {index === followUpActionQuestion.length - 1 && (
                <CommentTextbox
                  name={`Comments - ${index}`}
                  className="translate"
                  placeholder="Comments"
                  Value={
                    onOtherCommentValue && onOtherCommentValue[index]
                      ? onOtherCommentValue[index].followUpComment
                      : ''
                  }
                  handlechange={(e) => {
                    if (handleOtherCommentChange) {
                      handleOtherCommentChange(e, index);
                    }
                  }}
                  maxLength={200}
                />
              )}
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );
}

export default ASQFollowUpActionComponent;
